import type { IPublicClientApplication } from '@azure/msal-browser'
import { apiFetch } from './client'
import type { HistoryQuery, HistoryResponse } from './historyTypes'

const isoZ = (s: number) => new Date(s * 1000).toISOString()

/**
 * GET /api/v1/me/history. system_id is always sent: the browser may cache
 * closed ranges for a day, and a distinct URL per system keeps one customer's
 * cached data from ever answering another's request on a shared computer
 * (the API also sends Vary: Authorization).
 */
export function getHistory(
  msalInstance: IPublicClientApplication,
  q: HistoryQuery,
): Promise<HistoryResponse> {
  const params = new URLSearchParams({ system_id: String(q.systemId) })
  if (q.since != null) params.set('since', isoZ(q.since))
  if (q.from != null) params.set('from', isoZ(q.from))
  if (q.to != null) params.set('to', isoZ(q.to))
  return apiFetch<HistoryResponse>(msalInstance, `/api/v1/me/history?${params.toString()}`)
}
